'use es6';

import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import { DISTANCE_MEASUREMENT_MEDIUM } from 'HubStyleTokens/sizes';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import UIHeader from '../layout/UIHeader';
import omit from '../utils/underscore/omit';
import { jsx as _jsx } from "react/jsx-runtime";
const Subheader = styled(UIHeader).withConfig({
  displayName: "UISubheader__Subheader",
  componentId: "sc-1abx041-0"
})(["margin-bottom:", ";padding-top:0;"], DISTANCE_MEASUREMENT_MEDIUM);
function UISubheader(_ref) {
  let props = Object.assign({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/_jsx(Subheader, Object.assign({}, props, {
    fullWidth: true,
    flush: true,
    use: "condensed"
  }));
}
UISubheader.propTypes = Object.assign({}, omit(UIHeader.propTypes, ['flush', 'fullWidth', 'headingLevel', 'use']), {
  headingLevel: PropTypes.oneOf(['h2', 'h3', 'h4', 'h5', 'h6']),
  role: PropTypes.string
});
UISubheader.defaultProps = {
  headingLevel: 'h2',
  role: 'presentation'
};
UISubheader.displayName = 'UISubheader';
export default UISubheader;